export default [
  {
    path: '/activity-20250913-main',
    component: () => import('./Page.vue'),
    meta: { title: '甜蜜约会' },
  }
]
